import axios from "axios";
import { get } from "lodash";
import { all, fork, put, takeLatest, select } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import * as types from "~/store/followUpExam/types";
import * as hospitalTypes from "~/store/hospital/hospitalTypes";
import * as totalDataTypes from "~/store/totalData/types";
import * as userTypes from "~/store/user/userType";
import { getStepFollowTreeMap } from "~/utils/func";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";

const nodeAction = {
  service: {
    typeSelect: totalDataTypes.SELECT_SERVICE,
    typeReset: totalDataTypes.RESET_SELECT_SERVICE,
    url: "/chon-dich-vu"
  },
  subject: {
    typeSelect: totalDataTypes.SELECT_SUBJECT,
    typeReset: totalDataTypes.RESET_SELECT_SUBJECT,
    url: "/chon-chuyen-khoa"
  },
  doctor: {
    typeSelect: totalDataTypes.SELECT_DOCTOR,
    typeReset: totalDataTypes.RESET_SELECT_DOCTOR,
    url: "/chon-bac-si"
  },
  room: {
    typeSelect: totalDataTypes.SELECT_ROOM,
    typeReset: totalDataTypes.RESET_SELECT_ROOM,
    url: "/chon-phong-kham"
  }
};

function* requestGetFollowUpExam({ url }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const response = yield client.reExam({ url }, { platform });

    const {
      data: { isRequiredBooking, message }
    } = response;

    // Login
    const user = get(response, "data.user");
    const displayName = user.fullname ? user.fullname : user.username;
    const userInfo = { ...user, displayName };
    const bookingTree = get(response, "data.bookingTreeData");
    yield put({ type: userTypes.GET_USER_INFO_BY_CODE_SUCCESS, userInfo });
    client.setToken(user.token);
    console.log("user.token requestGetFollowUpExam :>> ", user.token);
    axios.defaults.headers.common.Authorization = `Bearer ${user.token}`;
    window.localStorage.setItem("jwt", user.token);

    if (isRequiredBooking) {
      // Login
      // const user = get(response, "data.user");
      // const displayName = user.fullname ? user.fullname : user.username;
      // const userInfo = { ...user, displayName };
      // const bookingTree = get(response, "data.bookingTreeData");
      // yield put({ type: userTypes.GET_USER_INFO_BY_CODE_SUCCESS, userInfo });
      // axios.defaults.headers.common.Authorization = `Bearer ${user.token}`;
      // window.localStorage.setItem("jwt", user.token);

      // booking tree
      const partnerid = get(response, "data.reExam.partnerId", "");
      const stepOne = getStepFollowTreeMap(bookingTree.subType, partnerid);
      yield put({
        type: totalDataTypes.GET_BOOKING_TREE_SUCCESS,
        payload: bookingTree
      });
      // history.push(stepOne);
      const firstNode = get(bookingTree, "child", []);
      const firstType = get(bookingTree, "subType");
      if (firstNode.length === 1) {
        if (
          firstType === "service" &&
          firstNode[0].detail.serviceType === "BOTH"
        ) {
          history.push(stepOne);
        } else {
          console.log(nodeAction[firstType].typeSelect);
          yield put({
            type: nodeAction[firstType].typeSelect,
            payload: firstNode[0]
          });
        }
      } else {
        history.push(stepOne);
      }

      // add patient re-exam
      const patient = get(response, "data.patient");
      yield put({
        type: types.GET_FOLLOW_UP_EXAM_SUCCESS,
        payload: patient
      });

      // select partnerid
      yield put({
        type: totalDataTypes.SET_PARTNER_ID,
        payload: partnerid
      });

      // get list hospital and select
      yield put({
        type: hospitalTypes.REQUEST_HOSPITAL_LIST
      });
      yield put({
        type: hospitalTypes.SELECT_HOSPITAL_BY_ID,
        id: partnerid
      });

      // save reexam id
      yield put({
        type: types.SAVE_REEXAM_ID,
        id: get(response, "data.reExam.id", "")
      });
    } else {
      history.push({ pathname: "/user", state: { activeItem: 2 } });
      openToast(message, "error");
    }
  } catch (error) {
    const message = get(error, "response.data.message");
    openToast(message, "error");
    history.push("/");
  }
}

function* watcherGetFollowUpExem() {
  yield takeLatest(types.GET_FOLLOW_UP_EXAM, requestGetFollowUpExam);
}

// check follow up exam
function* requestCheckFollowUpExam({ phone }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const response = yield client.reExamSearch(
      {
        phone
      },
      { partnerid: AppId, platform }
    );
    yield put({
      type: types.CHECK_FOLLOW_UP_EXAM_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log(JSON.stringify(error.response.data, null, 2));
  }
}

function* watcherCheckFollowUpExam() {
  yield takeLatest(types.CHECK_FOLLOW_UP_EXAM, requestCheckFollowUpExam);
}

export default function* root() {
  yield all([fork(watcherGetFollowUpExem), fork(watcherCheckFollowUpExam)]);
}
